import { translations as PageHeaderTranslations } from 'components/page/i18n/locales/fr/translations';
import { translations as BulkActionFrTranslation } from 'containers/BulkAction/i18n/locales/fr/translations';
import { translations as CampaignTranslations } from 'containers/Campaign/i18n/locales/fr/translations';
import { translations } from 'containers/Customer/i18n/locales/fr/translations';
import { translations as RewardFRTranslation } from 'containers/Reward/i18n/locales/fr/translations';
import { translations as RuleTranslations } from 'containers/Rule/i18n/locales/fr/translations';
import { translations as GlobalTranslations } from 'utils/globalTranslation/locales/fr/translations';
import {
  BulkActionModule,
  CampaignModule,
  CustomerModule,
  GlobalModule,
  PageHeaderModule,
  RewardModule,
  RuleModule
} from 'utils/i18n/TModules';

export const globalTranslations = {
  [GlobalModule]: GlobalTranslations,
  [BulkActionModule]: BulkActionFrTranslation,
  [CustomerModule]: translations,
  [CampaignModule]: CampaignTranslations,
  [PageHeaderModule]: PageHeaderTranslations,
  [RuleModule]: RuleTranslations,
  [RewardModule]: RewardFRTranslation
};
